import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { colors } from '../../constants/colors'
import './SideMenu.css'

const SideMenu = ({ isOpen = true }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      path: '/dashboard',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="3" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="11" y="3" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="3" y="11" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="11" y="11" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
      )
    },
    {
      id: 'usage-reports',
      label: 'Usage Reports',
      path: '/usage-reports',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="4" width="16" height="12" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path d="M6 10L8 12L14 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M5 8H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      )
    },
    {
      id: 'customer-management',
      label: 'Customer Management',
      path: '/customer-management',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="4" width="14" height="12" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path d="M7 8H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M7 11H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          <circle cx="6" cy="6" r="1" fill="currentColor"/>
        </svg>
      )
    },
    {
      id: 'billing-management',
      label: 'Billing Management',
      path: '/billing-management',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="4" width="14" height="12" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path d="M7 8H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M7 11H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          <circle cx="6" cy="6" r="1" fill="currentColor"/>
        </svg>
      )
    }
  ]

  const handleNavigation = (path) => {
    navigate(path)
  }

  if (!isOpen) return null

  return (
    <aside className="side-menu">
      {/* Header with Logo */}
      <div className="side-menu-header">
        <div className="logo-container">
          <div className="logo-circle">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill={colors.primary}/>
              <path d="M8 10h8v2H8v-2zm0 4h6v2H8v-2z" fill="#ffffff"/>
            </svg>
          </div>
          <div className="brand-text">
            <h1 className="brand-name">KBI</h1>
            <p className="brand-subtitle">ProgressArc</p>
          </div>
        </div>
        <div className="collapse-icon">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 4L10 8L6 12" stroke={colors.text.light} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>

      {/* Navigation Items */}
      <nav className="side-menu-nav">
        {menuItems.map((item) => {
          // Highlight dashboard for both "/" and "/dashboard" paths
          const isActive = item.id === 'dashboard' 
            ? (location.pathname === '/' || location.pathname === '/dashboard')
            : location.pathname === item.path
          
          return (
            <button
              key={item.id}
              className={`nav-item ${isActive ? 'nav-item-active' : ''}`}
              onClick={() => handleNavigation(item.path)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </button>
          )
        })}
      </nav>
    </aside>
  )
}

export default SideMenu

